import type { ReactNode } from "react";
import { PageMetadataContext, type PageMetadata } from "./pageMetadata";

/** Die Router-Anbindung liefert nur Daten. Der zuständige Seitenrahmen rendert den Kopf. */
export function PageMetadataProvider({ value, children }: { value: PageMetadata | null; children: ReactNode }) {
  return <PageMetadataContext.Provider value={value}>{children}</PageMetadataContext.Provider>;
}
